import React from "react";

const Loading = () => {
  return (
    <div>
      <img src="https://i.ibb.co/30VT0LQ/spinning-loading.gif" alt="" />
    </div>
  );
};

export default Loading;
